const env = process.env.REACT_APP_ENV;

let config = {
	AWARNESS_WEB_URL: "https://localhost:3000/",
	BACKEND_URL: "http://localhost:8000",
	BACKEND_API_URL: "http://localhost:8000/api/v1",
};

if (env === "local") {
	config = {
		...config,
		AWARNESS_WEB_URL: "https://localhost:3000/",
		BACKEND_URL: "https://localhost:8000",
		BACKEND_API_URL: "https://localhost:8000/api/v1",
	};
}

if (env === "dev") {
	config = {
		...config,
		AWARNESS_WEB_URL: "https://92.241.54.25/",
		BACKEND_URL: "https://92.241.54.25:444",
		BACKEND_API_URL: "https://92.241.54.25:444/api/v1",
	};
}

if (env === "stage") {
	config = {
		...config,
		AWARNESS_WEB_URL: "https://abc.arabbank.plc/",
		BACKEND_URL: "https://backend.abc.arabbank.plc",
		BACKEND_API_URL: "https://backend.abc.arabbank.plc/api/v1",
	};
}

if (env === "prod") {
	config = {
		...config,
		AWARNESS_WEB_URL: "https://abc.menafccg.com/",
		BACKEND_URL: "https://backend.abc.menafccg.com",
		BACKEND_API_URL: "https://backend.abc.menafccg.com/api/v1",
	};
}

export default config;
